import { Mail, MailX } from "lucide-react";

type Props = {
  connected: boolean;
  className?: string;
};

/** Green envelope when a custom address is active; red crossed envelope when using the default. */
export function MailAddressConnectionIcon({
  connected,
  className = "",
}: Props) {
  const base = `w-5 h-5 shrink-0 ${className}`.trim();
  if (connected) {
    return (
      <Mail
        className={`${base} text-emerald-600`}
        strokeWidth={2}
        aria-hidden
      />
    );
  }
  return (
    <MailX className={`${base} text-red-600`} strokeWidth={2} aria-hidden />
  );
}
